import styled from 'styled-components';

/**
 * A plain styled select. The design system's ButtonDropdown is a trigger primitive that must be
 * wrapped in a DropdownList and does not accept value/options/onChange, so it does not fit a
 * simple one-of-three picker.
 */
export const Select = styled.select`
	width: 100%;
	padding: 8px;
	font-size: 13px;
	border: 1px solid ${({theme}) => theme.sys.color.border.decorative};
	border-radius: 4px;
	background: ${({theme}) => theme.sys.color.background.neutral['1']};
`;
